import { validateEmail } from '../../lib/funnels/functions/v1/formats/validateEmail.js'
import { showInputError } from '../../lib/funnels/functions/v1/html/showInputError.js'
import { hideInputError } from '../../lib/funnels/functions/v1/html/hideInputError.js'
import { setUpFormInputs } from '../../lib/funnels/functions/v1/html/setupFormInputs.js'

// Wait for DOM to be ready
document.addEventListener('DOMContentLoaded', function () {
  // Set up form inputs (phone mask, validation, etc.)
  setUpFormInputs()

  const form = document.getElementById('signup-form')

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault()

      const nameInputElement = /** @type {HTMLInputElement} */ (
        document.getElementById('name')
      )
      if (!nameInputElement) return

      const nameValue = nameInputElement.value.trim()

      if (!nameValue) {
        nameInputElement.setAttribute('data-error-message', 'Name is required')
        showInputError(nameInputElement)
        return
      }

      const emailInputElement = /** @type {HTMLInputElement} */ (
        document.getElementById('email')
      )
      if (!nameInputElement) return

      const emailValue = emailInputElement.value.trim()

      if (!emailValue) {
        emailInputElement.setAttribute(
          'data-error-message',
          'Email is required',
        )
        showInputError(emailInputElement)
        return
      }

      if (!validateEmail(emailValue)) {
        emailInputElement.setAttribute(
          'data-error-message',
          'Please enter a valid email',
        )
        showInputError(emailInputElement)
        return
      }

      hideInputError(nameInputElement)
      hideInputError(emailInputElement)

      // Hide the form
      const formContainer = document.getElementById('signup-form-container')
      const successMessage = document.getElementById('success-message')

      if (formContainer) {
        formContainer.style.display = 'none'
      }

      if (successMessage) {
        successMessage.style.display = 'block'
      }
    })
  }
})
